import { render, staticRenderFns } from "./AppRegistration.vue?vue&type=template&id=cccdedea&scoped=true&"
import script from "./AppRegistration.vue?vue&type=script&lang=js&"
export * from "./AppRegistration.vue?vue&type=script&lang=js&"
import style0 from "./AppRegistration.vue?vue&type=style&index=0&id=cccdedea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cccdedea",
  null
  
)

export default component.exports